import React, { useState, MouseEvent, ReactNode } from "react";
import "./ImageTooltip.css";
import { device } from "../../utils/helpers";

interface TooltipProps {
  children: ReactNode;
  title: string;
  tipStyle?: object;
  containerStyle?: object;
}

function Tooltip({ children, title, tipStyle, containerStyle }: TooltipProps) {
  const [isShowTooltip, setTooltipVisibility] = useState(false);
  tipStyle = { ...tipStyle, display: isShowTooltip ? "block" : "none" }

  const showTooltip = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (device() !== "pc") return;
    setTooltipVisibility(true);
  };

  const hideTooltip = () => {
    setTooltipVisibility(false);
  };

  const overTooltip = () => {
    setTooltipVisibility(false);
  }

  return (
    <div
      className="tooltip-container"
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
      style={containerStyle}
    >
      {children}
      {
        <div className="tooltip" onMouseEnter={overTooltip} style={tipStyle}>
          <div className="tooltip-content">
            {
              <img src={require(`../../assets/image/${title}`)} alt={title} />
            }
          </div>
        </div>
      }
    </div>
  );
}

export default Tooltip;